import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';

import CampaignPromotionModel from './promotion-model';
import CampaignPromotionCollection from './promotion-collection';

function cloneCampaignPromotion({ id, name }) {
  return ajaxService
    .post('/api/promotion/clone.json', { id, name })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(CampaignPromotionModel.deserialize)
    .catch((error) => ({ error }));
}

function createCampaignPromotion(promotion, defaultParams) {
  return ajaxService
    .post('/api/promotion/save.json', { ...promotion, ...defaultParams })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(CampaignPromotionModel.deserialize)
    .catch((error) => ({ error }));
}

function publishCampaignPromotion(id) {
  return ajaxService
    .post('/api/promotion/publish.json', { id })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then((response) => {
      const successMessage = response.data.statusmsg;
      const promotion = CampaignPromotionModel.deserialize(ApiUtils.extract1(response));
      return { successMessage, promotion };
    })
    .catch((error) => ({ error }));
}

function draftCampaignPromotion(id) {
  return ajaxService
    .post('/api/promotion/draft.json', { id })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then((response) => {
      const successMessage = response.data.statusmsg;
      const promotion = CampaignPromotionModel.deserialize(ApiUtils.extract1(response));
      return { successMessage, promotion };
    })
    .catch((error) => ({ error }));
}

function deleteCampaignPromotion(id) {
  return ajaxService
    .post('/api/promotion/delete.json', { id })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then((response) => ({ successMessage: response.data.statusmsg }))
    .catch((error) => ({ error }));
}

function updateCampaignPromotions(promotions) {
  return ajaxService
    .post(
      '/api/xp/reward/upsert.json',
      _.map(promotions, (promotion) => CampaignPromotionModel.serialize(promotion)),
      undefined,
      { timeout: 0, postJSON: true }
    )
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then((response) => _.map(response, (reward) => CampaignPromotionModel.deserialize(reward)));
}

function fetchCampaignPromotions({ order = 'asc', sort, containerRef, typeRef }) {
  return ajaxService
    .post(
      '/api/promotion/list.json',
      {
        order,
        sort,
        containerRef,
        typeRef_filter: typeRef,
        max:            1000,
        offset:         0,
      },
      {},
      { cache: false }
    )
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(CampaignPromotionCollection.deserialize);
}

export default {
  cloneCampaignPromotion,
  createCampaignPromotion,
  deleteCampaignPromotion,
  draftCampaignPromotion,
  fetchCampaignPromotions,
  publishCampaignPromotion,
  updateCampaignPromotions,
};
